import { MY_DSO } from '@app/shared/constants';
import { StringUtility } from '@app/shared/string-utility';

export class InformationUtlity {
  private static readonly CUSTOMER_COMPLAINT_INFORMATION_ID = '9F7E8A4D-6C31-4A92-BF75-2E8D4C1A7B63';
  private static readonly CUSTOMER_COMPLAINT_FILE_EXTENSIONS = ['csv', 'xlsx', 'xls'];
  private static readonly CUSTOMER_COMPLAINT_MIME_TYPES = [
    'text/csv',
    'application/csv',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];

  public static isFileNameWithinLimits(files: FileList): boolean {
    const fileName = files[0].name;
    const fileNameWithoutExtension = fileName.substring(0, fileName.lastIndexOf('.')) || fileName;
    const fileNameLength = fileNameWithoutExtension.length;

    return fileNameLength <= 50;
  }

  public static isMimeTypeSupported(files: FileList, isPreviewImage: boolean): boolean {
    const mimeType = files[0].type;
    const fileName = files[0].name;
    const supportedMimeTypes = isPreviewImage ? MY_DSO.SUPPORTED_MIME_TYPES.PREVIEW_IMAGE : MY_DSO.SUPPORTED_MIME_TYPES.ATTACHMENT;
    const hasSupportedMimeType = StringUtility.hasAnyMatchInArray(supportedMimeTypes, [mimeType]);

    if (!isPreviewImage && this.isCustomerComplaintFile(fileName, mimeType)) {
      return true;
    }

    return hasSupportedMimeType;
  }

  public static isFileSizeWithinLimits(fileSize: number): boolean {
    return fileSize <= MY_DSO.MAX_FILE_SIZE;
  }

  public static isCustomerComplaintFile(fileName: string, mimeType: string = ''): boolean {
    const extension = this.getFileExtension(fileName);
    const hasAllowedExtension = this.CUSTOMER_COMPLAINT_FILE_EXTENSIONS.includes(extension);
    if (hasAllowedExtension) {
      return true;
    }

    return StringUtility.hasAnyMatchInArray(this.CUSTOMER_COMPLAINT_MIME_TYPES, [mimeType]);
  }

  public static isCustomerComplaintInformation(info: { id?: string }): boolean {
    return (info?.id || '').toUpperCase() === this.CUSTOMER_COMPLAINT_INFORMATION_ID;
  }

  private static getFileExtension(fileName: string): string {
    const fileNameParts = (fileName || '').split('.');
    if (fileNameParts.length <= 1) {
      return '';
    }

    return fileNameParts[fileNameParts.length - 1].toLowerCase();
  }
}
